import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Distribuição de Notas',
    path: '/academico/distribuicao/cadastro',
    name: 'distribuicao',
    component: () => import('@/views/academico/distribuicao/cadastro/Index.vue'),
    meta: {
      permissions: [
        eTipoPermissao.DEFINIRFORMADELANCAMENTO_MENU_300302401
      ],
    },
    goesToMenu: false,
    routeOnChangeEscolaAnoSemestre: 'distribuicao'
  },
]

